module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo04-1f9985f3bb319a7e60f3f02b228868cb.jpg";